export const CheckboxTestIdFactory = {
    getCheckboxBase: () => 'checkbox',
    getCheckboxGroupBase: () => [CheckboxTestIdFactory.getCheckboxBase(), 'group'].join('-'),
    getCheckboxGroupLabelBase: () => [CheckboxTestIdFactory.getCheckboxGroupBase(), 'label'].join('-'),
    getCheckboxContainerTestId: (testId) => [CheckboxTestIdFactory.getCheckboxBase(), 'container', testId].join('-'),
    getCheckboxInputTestId: (testId) => [CheckboxTestIdFactory.getCheckboxBase(), 'input', testId].join('-'),
    getCheckboxDescriptionTestId: (testId) => [CheckboxTestIdFactory.getCheckboxBase(), 'description', testId].join('-'),
    getCheckboxGroupTestId: (testId) => [CheckboxTestIdFactory.getCheckboxGroupBase(), testId].join('-'),
    getCheckboxGroupLabelTestId: (testId) => [CheckboxTestIdFactory.getCheckboxGroupLabelBase(), testId].join('-'),
};
